import { SketchElement } from '../../../../../inspector'

/**
 * Generic function to find a sketch element in the tree using a predicate function.
 */
export function findSketchElement(
  sketchSceneRootElement: SketchElement | null,
  predicate: (element: SketchElement) => boolean
): SketchElement | null {
  if (!sketchSceneRootElement) {
    return null
  }

  function searchElement(element: SketchElement): SketchElement | null {
    // Check if current element matches the predicate
    if (predicate(element)) {
      return element
    }

    // Recursively search in children
    for (const child of element.children) {
      const found = searchElement(child)
      if (found) {
        return found
      }
    }

    return null
  }

  return searchElement(sketchSceneRootElement)
}

export function findSketchElementFromUuid(
  sketchSceneRootElement: SketchElement | null,
  uuid: string
): SketchElement | null {
  return findSketchElement(
    sketchSceneRootElement,
    element => element.elementUUID === uuid
  )
}

export function findSketchElementFromLayerPathHash(
  sketchSceneRootElement: SketchElement | null,
  layerPathHash: string
): SketchElement | null {
  return findSketchElement(
    sketchSceneRootElement,
    element => element.layerPathHash === layerPathHash
  )
}
